import { Select } from '@cabonline/ui-web';
import { LanguageOutlined } from '@mui/icons-material';
import {
  LanguageKey,
  storageInstance,
  useLocale,
} from '@multiplatform-apps/service-trips';
import { FC, useCallback, useEffect } from 'react';

import { languages } from '../../constants';

export const LanguageSelect: FC<{ id: string; darkMode?: boolean }> = ({
  id,
  darkMode = false,
}) => {
  const { t, currentLanguage, setCurrentLanguage } = useLocale();

  useEffect(() => {
    document.documentElement.lang = currentLanguage;
  }, [currentLanguage]);

  const handleChange = useCallback(
    (language: LanguageKey) => {
      storageInstance.setData('currentLanguage', language);
      setCurrentLanguage(language);
    },
    [setCurrentLanguage]
  );

  return (
    <Select
      id={id}
      options={languages}
      onChange={(item) => handleChange(String(item?.value) as LanguageKey)}
      value={languages.find((item) => item.value === currentLanguage)}
      aria-label={t('languageSelect.ariaLabel')}
      isSearchable={false}
      darkMode={darkMode}
      prefixIcon={<LanguageOutlined />}
      formatOptionLabel={(option, { context }) =>
        context === 'value' ? option.shortLabel : option.label
      }
    />
  );
};
